<table mat-table class="stripped-table mat-elevation-z2" [dataSource]="fundDataSource" matSort>
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Fund Name</th>
    <td mat-cell *matCellDef="let row"><a href="{{dataFormat.formatLink({id: row.fund_id, name: row.name, __typename: 'Fund'})}}" class="data-link">{{row.name}}</a></td>
  </ng-container>
  <ng-container matColumnDef="fund_type">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Fund Type</th>
    <td mat-cell *matCellDef="let row">{{row.fund_type}}</td>
  </ng-container>
  <ng-container matColumnDef="repeat">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>New/Repeat</th>
    <td mat-cell *matCellDef="let row">{{row.repeat ? 'Repeat' : 'New'}}</td>
  </ng-container>
  <ng-container matColumnDef="investment_amount">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Investment Amount</th>
    <td mat-cell *matCellDef="let row">{{row.amount | currency: 'USD' : 'symbol': '1.0-0'}}</td>
  </ng-container>
  <ng-container matColumnDef="investment_class">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Investment Class</th>
    <td mat-cell *matCellDef="let row">{{row.investment_class}}</td>
  </ng-container>
  <ng-container matColumnDef="admitted_date">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Admission Date</th>
    <td mat-cell *matCellDef="let row">{{row.admitted_date | date: 'MM/dd/yyyy'}}</td>
  </ng-container>
  <ng-container matColumnDef="exit_date">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Exit Date</th>
    <td mat-cell *matCellDef="let row">{{row.exit_date | date: 'MM/dd/yyyy'}}</td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef=fundInvestmentsColumns></tr>
  <tr mat-row *matRowDef="let row; columns: fundInvestmentsColumns"></tr>
</table>
